import React from "react";
import { Divider as PDivider } from 'primereact/divider';
import {extract, renderValue} from "../utils";

const Spacer = ({extraConfig, ...rest}) => {
    const {height,display_status} = extraConfig
    if(display_status === 'hidden')return <></>
    return <div style={{height: `${height || 100}px`}}/>
};
export const FormSpacer = Spacer;
